import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-consulta-historico-venda',
  templateUrl: './consulta-historico-venda.component.html',
  styleUrls: ['./consulta-historico-venda.component.scss']
})
export class ConsultaHistoricoVendaComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';

  listaFotos:any[] = [];

  @Input() token = '';

  constructor() { }

  ngOnInit() { }

  ngOnChanges() {
    this.formatarListaFotos();
  }

  formatarListaFotos() {
    let i=0;
    this.listaFotos = this.consulta ? Object.keys(this.consulta).map(k => this.consulta['foto' + (i++)]).filter(k => k) : [];

    for(let j = 0; j<this.listaFotos.length; j++){
      this.listaFotos[j] = environment.wsUrl+"consulta/getImagemRemarketing?urlImagem="+this.listaFotos[j];
    }
  }
}
